// extracted by mini-css-extract-plugin
module.exports = {"section":"styles__section___30WIu","verticalTable":"styles__verticalTable___38hx_"};